import { Flex, Text } from '@sparrowengg/twigs-react'
import { DeleteIcon, EmailIcon } from '@sparrowengg/twigs-react-icons'
import React, { useState } from 'react'
import DeleteModal from './DeleteModal'

export default function SideNav({ setSmsData }) {
  const [deleteModal, setDeleteModal]=useState(false)
  return (
    <>
    <Flex flexDirection="column" css={{
      marginBottom: 0,
      height: `calc(100vh - 60px)`,
      background: '#EAEFF4',
    }}>
      <Flex id="sparrowConnect-viewAllMessages"
        gap="$2"
        justifyContent="start"
        css={{
          padding: '$6 $12',
          backgroundColor: '#B0C4DE',
          cursor: 'pointer',
          borderBottom:'solid 1px $black400',
        }}

      >
        <EmailIcon size={"24px"}/>
        <Text size="md">
          Messages
        </Text>
      </Flex>
      <Flex id="sparrowConnect-deleteAll"
        gap="$2"
        justifyContent="start"
        css={{
          padding: '$6 $12',
          cursor: 'pointer',
          borderBottom:'solid 1px $black400',
          '&:hover': {
            backgroundColor: '#B0C4DE',
          }
        }}
        onClick={() => {
          setDeleteModal(true)
        }}
      >
        <DeleteIcon size={"24px"}/>
        <Text size="md">
          Delete all message
        </Text>
      </Flex>
      
      </Flex>
      {deleteModal && <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} setSmsData={setSmsData } />}
      </>
  )
}
